import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { IWareHouseFieldsProps } from "@/app/components/routes/auth_routes/Configuration/WarehouseOnboardComponent/WarehouseAddComponent";
import { useDispatch } from "react-redux";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

AxiosCurlirize(axios, () => {});
export const useWareHouseUpdateAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const dispatch = useDispatch();

  const execute = useCallback(
    async (wareHousepropsData: IWareHouseFieldsProps, warehouse_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: InventoryTaxCreateAPIResponse = await axios
          .put(`${CONFIGURATION_APIS?.WAREHOUSE_API?.baseURL}details/${warehouse_id}/`, wareHousepropsData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              toast.success(`${wareHousepropsData?.display_name} has been updated. `);
              return { status: true, message: "batch" };
            } else {
              toast.error("Updation Faild");
              return { status: false, message: "batch_not_created" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e)
            return { status: false, message: "batch_not_created" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
